module.exports = __webpack_public_path__ + "assets/img/jianjie1.a2f6d587.png";